const $kspace = require("./kspace");
const $CommFuncs = window.$CommFuncs;
const $kmupload = require("./kmupload.js");
const $kmobile = require("./kmobile");
const $kutil = require("./kutil.js");

const kmutils = {
  _ToastCloseTimeout: 3000,
};
// 批量获取语言包
// 格式: $kmutils.getLangs({自定义key: '语言包key', docmuent:'doc.document'});
// 输出: {自定义key: '语言包key', docmuent:'文档'};
kmutils.getLangs = function (langs) {
  let vuelocale = localStorage.getItem("kabala.locale") || "zh-CN"; // 'en-US';
  return $KabalaI18n.t(vuelocale, langs);
};
/**
 * 获取通用组件信息
 */
kmutils.getCommonRoutes = function (basePath) {
  if (!basePath) {
    basePath = "./";
  }
  let res = [];
  for (var i = 0; i < commonRoutes.length; i++) {
    let temp = $CommFuncs.extendAttrs({}, commonRoutes[i]);
    temp.componentUrl = basePath + temp.componentUrl;
    res.push(temp);
  }
  return res;
};
kmutils.getTopApp = function () {
  let app = $app ? $app : undefined;
  try {
    let topapp = window.$app
      ? window.$app
      : window.top && window.top.$app
      ? undefined
      : window.top.$app;
    app = topapp ? topapp : app;
  } catch (e) {
    console.error(e);
  }
  if (!app) {
    // 跨域或者嵌套
    let parent = window;
    while (true) {
      if (!parent) {
        break;
      }
      app = parent.$app ? parent.$app : undefined;
      if (app) {
        break;
      }
      if (parent === window.parent) {
        break;
      }
      parent = window.parent;
    }
  }
  return app;
};
// 显示加载框
kmutils.showLoader = function () {
  kmutils.getTopApp().$toast.loading({
    className: "k-loading",
    position: "top",
    duration: 0,
    forbidClick: true,
    message: "加载中...",
    loadingType: "spinner",
  });
};
// 显示加载框
kmutils.hideLoader = function () {
  kmutils.getTopApp().$toast.clear();
};
// 居中提示框
kmutils.tips = function (text) {
  kmutils.hideLoader();
  let res = kmutils.getTopApp().toast.create({
    text: text,
    position: "center",
    closeTimeout: kmutils._ToastCloseTimeout,
  });
  return res.open();
};
// 错误提示框
kmutils.failTips = function (text) {
  kmutils.hideLoader();
  let res = kmutils.getTopApp().toast.create({
    text: text,
    position: "center",
    closeTimeout: kmutils._ToastCloseTimeout,
  });
  return res.open();
};
// 顶部提示框
kmutils.topTips = function (text) {
  kmutils.hideLoader();
  let res = kmutils.getTopApp().toast.create({
    text: text,
    position: "top",
    closeTimeout: kmutils._ToastCloseTimeout,
  });
  return res.open();
};

/**
 * 预览文件 - 内部跳转
 */
kmutils.preview = function (
  ctx,
  { spacePath, goBackPath, showFileList, otherParams }
) {
  ctx.$router.push({
    name: "Filepreview",
    params: {
      spacePath,
      goBackPath,
      showFileList,
      otherParams,
    },
  });
};
/**
 * 预览文件 - 自动识别打开方式
 */
kmutils.openPreview = function (
  ctx,
  { spacePath, goBackPath, showFileList, otherParams }
) {
  // kmutils.showLoader( );

  $kspace
    .askviewurl(spacePath)
    .then((data) => {
      // kmutils.hideLoader( );
      console.log("spacePath=>", data);
      // app端校验
      // alert($CommFuncs.checkBrowser('App'))
      // if( $CommFuncs.checkBrowser('App') ){
      //     alert(2)
      //     let title = spacePath.getName();
      //     let url = '/pan/mobile/pages/page/file-preview.html?path='+ encodeURIComponent( spacePath );
      //     $kmobile.newpage(url, title, false, [])
      // }else{
      kmutils.preview(ctx, {
        spacePath: encodeURIComponent(spacePath),
        goBackPath,
        showFileList,
        otherParams,
      });
      // }
    })
    .catch((err) => {
      ctx.$toast.fail(err.toString());
    });
};
/**
 * 打开一个新的页面 - iframe
 */
kmutils.newpage = function (ctx, { url, title, goBackPath, otherParams }) {
  // alert(url)
  let newUrl = url;
  let isViewflow = newUrl.indexOf("/main/flow/viewflow.html") > -1;
  if (isViewflow) {
    newUrl = newUrl.replace(
      "/main/flow/viewflow.html",
      "/main/flow/viewflow_mobile.html"
    );
  }
  // if( $CommFuncs.checkBrowser('App') ){
  // $kmobile.newpage(url, title?title:'', false, [])
  // }else{

  ctx.$router.push({
    name: "Urlpreview",
    params: {
      url: newUrl,
      title: title ? title : "&nbsp;",
      goBackPath,
      otherParams,
    },
  });
  // }
};
// 绑定选则文件上传
kmutils.bindUpload = function (opts) {
  // console.log('绑定选则文件上传 kmupload',opts)
  /*if( kmutils.uploader ){
     try{
     kmutils.uploader.uploader.destroy( );
     kmutils.uploader = null;
     }catch(err){ console.log(err); }
     }*/

  kmutils.uploader = new $kmupload.upload(opts);
  return kmutils.uploader;
};
// 微笑小程序工具
kmutils.wxMiniProgram = {
  doSendMsg: function (type, data) {
    let win = top || window;
    let token = $kutil.random();
    win.localStorage.setItem(
      "wx.miniprogram." + token,
      typeof data == "string" ? data : JSON.stringify(data)
    );
    wx.miniProgram.navigateTo({
      url: "/pages/com/message?type=send&token=" + token + "&msgtype=" + type,
    });
    return token;
  },
};
// 头像工具
kmutils.userHeaderTools = {
  // 获取缓存整体对象
  userHeaderCache: function (uid, url) {
    var localUserHeader = window.localStorage.getItem("kabala.userheader");
    if (
      localUserHeader !== undefined &&
      localUserHeader !== null &&
      localUserHeader.length > 0
    ) {
      return JSON.parse(localUserHeader);
    } else {
      return {};
    }
  },
  userHeaderCacheSet: function (uid, url) {
    var cache = kmutils.userHeaderTools.userHeaderCache();
    delete cache[uid];
    delete cache[uid + ".expiretime"];
    cache[uid] = url;
    cache[uid + ".expiretime"] = new Date().getTime() + 1 * 60 * 60 * 1000;
    window.localStorage.setItem("kabala.userheader", JSON.stringify(cache));
  },
  userHeaderCacheGet: function (uid) {
    if (uid == undefined || uid == null) return "";
    var obj = kmutils.userHeaderTools.userHeaderCache();
    if (Object.prototype.hasOwnProperty.call(obj, uid)) {
      //如果存在头像...
      var url = obj[uid];
      //检查头像是否过期...
      if (Object.prototype.hasOwnProperty.call(obj, uid + ".expiretime")) {
        var expiretime = obj[uid + ".expiretime"];
        if (new Date().getTime() > expiretime) {
          return "";
        } else {
          return url;
        }
      }
    }
  },
};

kmutils.userSelect = function (ctx, group, user, multi, callback, olduids) {
  ctx.$router.push({
    name: "CommUserSelect",
    params: {
      callback: $CommFuncs.addCallback(callback),
      group: group,
      user: user,
      multi: multi,
      uids: JSON.stringify(olduids ? olduids : []),
    },
  });
};

module.exports = kmutils;
